export default {
  settings: {}
};
